module.exports = __webpack_public_path__ + "static/icons/icon-caret-down--filled-fa162e3512de3a4a1626c68efe657771.svg";